import styled from 'styled-components';

export const Wrapper = styled.div`
  cursor: pointer;
  border: 1px dashed #cadcf8;
  border-radius: 5px;
  margin-bottom: 15px;

  :hover {
    border: 1px dashed #858dbd;
  }
`;
